"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M20.839 10.6612c-4.8816-4.8816-12.7962-4.8816-17.6777 0L1.747 9.247c5.6626-5.6626 14.8435-5.6626 20.5061 0l-1.4142 1.4142z"
  }), _react.default.createElement("path", {
    d: "M5.9897 13.4896c3.3195-3.3195 8.7014-3.3195 12.0208 0l1.4142-1.4142c-4.1005-4.1005-10.7487-4.1005-14.8492 0l1.4142 1.4142z"
  }), _react.default.createElement("path", {
    d: "M8.8181 16.318c1.7574-1.7574 4.6066-1.7574 6.364 0l1.4142-1.4142c-2.5384-2.5384-6.654-2.5384-9.1924 0l1.4142 1.4142zM12 20.0112c.8284 0 1.5-.6716 1.5-1.5 0-.8285-.6716-1.5-1.5-1.5s-1.5.6715-1.5 1.5c0 .8284.6716 1.5 1.5 1.5z"
  })];
};

exports.default = _default;